// Opsi konstan untuk dropdown & chip pada modul Alat Reuse.

export const KATEGORI_ALAT_REUSE = [
  "Bedah",
  "Endoskopi",
  "Laparoskopi",
  "Kateter",
  "Hemodialisa",
  "Anestesi",
  "Respirasi",
  "Obgyn",
  "Dental",
  "Lainnya",
];

export const METODE_STERILISASI = [
  "ETO",
  "Autoclave",
  "Cidex (OPA)",
  "Plasma H2O2",
  "Glutaraldehyde",
  "Steam",
  "Lainnya",
];

export const TINGKAT_KERUSAKAN = [
  { text: "Ringan", value: "ringan" },
  { text: "Sedang", value: "sedang" },
  { text: "Berat", value: "berat" },
];

export const TINDAKAN_KERUSAKAN = [
  { text: "Perbaiki", value: "perbaiki" },
  { text: "Tarik dari Peredaran", value: "tarik" },
  { text: "Musnahkan", value: "musnahkan" },
];

export const REUSE_STATUS_META: Record<
  string,
  { label: string; color: string; icon: string }
> = {
  aman: { label: "Aman", color: "success", icon: "mdi-check-circle" },
  mendekati_batas: {
    label: "Mendekati Batas",
    color: "warning",
    icon: "mdi-alert-circle",
  },
  batas_tercapai: {
    label: "Batas Tercapai",
    color: "error",
    icon: "mdi-close-octagon",
  },
  ditarik: {
    label: "Ditarik / Non-aktif",
    color: "grey darken-2",
    icon: "mdi-cancel",
  },
};
